module.exports = __webpack_public_path__ + "static/img/scyhy-D8o1Ve7V.4aaabd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/scyhy-D8o1Ve7V.png
// module id = pXEx
// module chunks = 16